import React from "react";
import { RxCrossCircled } from "react-icons/rx";

const Modal = ({ isOpen, onClose, htmlContent }) => {
  const htmlString =
    typeof htmlContent === "object" ? htmlContent.previewUrl : htmlContent;

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg w-3/4 max-w-5xl h-4/5 overflow-hidden flex flex-col">
        <RxCrossCircled className="self-end m-3 h-7 w-7" onClick={onClose} />
        <div
          className="flex-1 overflow-y-auto p-1"
          dangerouslySetInnerHTML={{ __html: htmlString }}
        />
      </div>
    </div>
  );
};

export default Modal;
